import { useTranslator } from "@eo-locale/react";

import { FiTrash } from "react-icons/fi";

import { ImWarning } from "react-icons/im";

import { Box, Menu, useDisclosure } from "@/storybook-components";

import DeletePin from "@/components/places/esri-map/action-items/delete-pin";
import EditPin from "@/components/places/esri-map/action-items/edit-pin";
import ReportPin from "@/components/places/esri-map/action-items/report-pin";
import useUser from "@/hooks/useUser";
import { useAppSelector } from "@/redux/store/hooks";

import useAccessStatus from "@/hooks/places/use-access-status";

const ActionList = ({ actionParams, rightPanelProps }: any) => {
  const { onClose, onOpen, isOpen } = useDisclosure();
  const {
    onClose: onDeleteClose,
    onOpen: onDeleteOpen,
    isOpen: isDeleteOpen
  } = useDisclosure();

  const { accessStatus } = useAccessStatus();
  const { translate } = useTranslator();
  const { id: userId } = useAppSelector(
    (state) => state.user.registeredUser.profile
  );

  const { moderated } = useAppSelector((state) => state.site.site);

  const isSameUser = userId === `${actionParams?.userId}`;
  const { isRegisteredUserLoggedIn } = useUser();

  const showReportPin =
    ((isRegisteredUserLoggedIn && !isSameUser) || !isRegisteredUserLoggedIn) &&
    moderated;

  const isSameLoggedInUser = isRegisteredUserLoggedIn && isSameUser;
  const showKebabMenu = isSameLoggedInUser || showReportPin;

  if (!showKebabMenu) {
    return null;
  }

  return accessStatus ? (
    <Box>
      <Menu
        menuAriaLabel={`${translate("common.actions")}`}
        menuButtonAriaLabel={`${translate("participantHeader.openMenu")}`}
      >
        {
          <>
            {isSameLoggedInUser && (
              <>
                <EditPin
                  markerId={actionParams.markerId}
                  rightPanelProps={rightPanelProps}
                />
                <Menu.Item
                  icon={<FiTrash />}
                  color="red.600"
                  _hover={{
                    backgroundColor: "red.600",
                    color: "white"
                  }}
                  onClick={() => onDeleteOpen()}
                >
                  {translate("common.delete")}
                </Menu.Item>
              </>
            )}

            {showReportPin && (
              <Menu.Item
                icon={<ImWarning />}
                _hover={{
                  backgroundColor: "gray.100"
                }}
                onClick={() => onOpen()}
              >
                {translate("common.report")}
              </Menu.Item>
            )}
          </>
        }
      </Menu>
      {showReportPin && (
        <ReportPin
          markerId={actionParams.markerId}
          onClose={onClose}
          isOpen={isOpen}
        />
      )}
      {isSameLoggedInUser && (
        <DeletePin
          actionParams={actionParams}
          onClose={onDeleteClose}
          isOpen={isDeleteOpen}
        />
      )}
    </Box>
  ) : null;
};

export default ActionList;
